import { NgModule } from '@angular/core';
import { RouterModule, Routes } from "@angular/router";
import { AssignTrainingComponent } from './components/assign-training/assign-training.component';
import { TncDashboardComponent } from './components/tnc-dashboard/tnc-dashboard.component';
import { UserProfileComponent } from './components/user-profile/user-profile.component';

const routes: Routes = [
  {
    path: '',
    pathMatch: 'full',
    redirectTo: 'assign-training'
  },
  {
    path: 'assign-training',
    component: AssignTrainingComponent
  },
  {
    path: 'assign-training/:tncId',
    component: AssignTrainingComponent
  },
  {
    path: 'tnc-overview',
    component: TncDashboardComponent
  },
  {
    path: 'user-profile',
    component: UserProfileComponent
  },
  {
    path: 'user-profile/:UserId',
    component: UserProfileComponent
  }

];

@NgModule({
  declarations: [],
  imports: [
    RouterModule.forChild(routes)
  ],
  exports: [RouterModule]
})
export class TrainingAndCompetencyRoutingModule { }
